module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAALCAYAAABcUvyWAAAAg0lEQVQYlU3OsQpBYQAF4O/eSRFl8xJK2diuUnabsv3lsZTNYlLK3diU8hKyKKJMWO5f/1m/OudkIYQFbtjgq0qOF7qYIEthjSv6KFL4YIU7hhhEgDeWeGKEXgR4YFftFCm0MMYPZYQ65mhij3OOGmZo44BjHJ+igxPK9G4DF2yrfvAH/8oaSMk6J3kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pageR.png
// module id = 1063
// module chunks = 1